<ng-container *ngIf="activeErrorsStore.selectedActiveError$ | async as selectedActiveError">
  <div *ngIf="selectedActiveError.details?.causes" class="flex flex-col gap-[16px]">
    <h2>{{ selectedActiveError.errorDescription }}</h2>
    <div class="flex flex-row lt-md:flex-col gap-[12px]">
      <div
        class="flex flex-col gap-[12px] flex-[40%] max-w-[40%] lt-md:flex-[100%] lt-md:max-w-[100%]"
      >
        <app-possible-cause
          data-at-possible-cause
          [causes]="selectedActiveError.details.causes"
        ></app-possible-cause>

        <ng-container
          *ngIf="
            (installationDetailsStore.getMainDevicePlatformByGateway(
              selectedActiveError.gatewaySerial
            ) | async) === platform.Legacy;
            else showDetailsForE3
          "
        >
          <app-legacy-device-note
            [isHeaderInside]="true"
            [header]="
              '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.ECU' | translate
            "
          >
          </app-legacy-device-note>
          <app-legacy-device-note
            [isHeaderInside]="true"
            [header]="
              '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.SYSTEM_BEHAVIOR'
                | translate
            "
          >
          </app-legacy-device-note>
        </ng-container>

        <ng-template #showDetailsForE3>
          <ng-container
            *ngIf="
              (installationDetailsStore.showActiveErrorsForE3(selectedActiveError.gatewaySerial)
                | async) === false;
              else showData
            "
          >
            <app-active-error-blur
              data-at-active-error-ecu
              data-at-blur
              [header]="
                '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.ECU' | translate
              "
              [section]="activeErrorDetailsSections.Ecu"
            >
            </app-active-error-blur>
            <app-active-error-blur
              data-at-active-error-system-bahavior
              data-at-blur
              [header]="
                '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.SYSTEM_BEHAVIOR'
                  | translate
              "
              [section]="activeErrorDetailsSections.SystemBehavior"
            >
            </app-active-error-blur>
          </ng-container>

          <ng-template #showData>
            <app-ecu
              data-at-active-error-ecu
              [gatewaySerial]="selectedActiveError.gatewaySerial"
            ></app-ecu>
            <app-system-behavior
              data-at-active-error-system-bahavior
              [systemCharacteristics]="selectedActiveError.details.systemCharacteristics"
            >
            </app-system-behavior>
          </ng-template>
        </ng-template>
      </div>

      <app-how-to-repair
        data-at-how-to-repair
        class="flex-1"
        [causes]="selectedActiveError.details.causes"
        [faultCode]="selectedActiveError.details.faultCode"
        [boilerSerial]="selectedActiveError.deviceSerial"
      ></app-how-to-repair>
    </div>
  </div>
</ng-container>
